import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import logo from "../assets/images/logo.png";
import "./goldDust.css";

const dustParticles = Array.from({ length: 100 });

export default function VendorLogin() {
  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Enter email & password");
      return;
    }

    try {
      const res = await fetch("/api/vendor/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Login successful ✅");

        window.location.href = "/vendordashboard";
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0b0b0f] via-[#12121a] to-[#0b0b0f]">
      {dustParticles.map((_, i) => (
        <span
          key={i}
          className="gold-dust"
          style={{
            left: `${Math.random() * 100}%`,
            width: `${Math.random() * 6 + 2}px`,
            height: `${Math.random() * 6 + 2}px`,
            animationDuration: `${Math.random() * 12 + 10}s`,
            animationDelay: `${Math.random() * 10}s`,
          }}
        />
      ))}

      <div className="absolute -top-32 -left-32 w-96 h-96 bg-amber-400/20 rounded-full blur-[140px]" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-yellow-600/20 rounded-full blur-[140px]" />
      <div className="absolute inset-0 luxury-pattern" />

      <div className="relative z-10 w-full max-w-lg">
        <div className="rounded-[20px] bg-white/[0.035] backdrop-blur-[30px] border border-white/10 px-10 py-12 flex flex-col shadow-[0_60px_140px_rgba(0,0,0,0.85)]">

          <div className="flex justify-center mb-8">
            <img src={logo} alt="Jaggi Sweets Vendor" className="w-14 h-14 opacity-90" />
          </div>

          <h1 className="text-[20px] uppercase text-center font-serif text-white">
            Jaggi Sweets
          </h1>

          <p className="mt-1 text-center text-[13px] text-gray-400">
            Sign in to manage your vendor account
          </p>

          <div className="bg-yellow-600 h-[3px] my-2 w-1/2 mx-auto"></div>

          <p className="mt-1 text-lg text-gray-400 text-center">
            Vendor Access Portal
          </p>

          <div className="h-10" />

          {/* EMAIL */}
          <input
            type="email"
            placeholder="Vendor Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border border-white/15 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 transition"
          />

          {/* PASSWORD */}
          <div className="relative w-full mt-4">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border border-white/15 rounded-xl px-4 py-3 pr-10 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 transition"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-200 transition"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          {/* BUTTON */}
          <button
            onClick={handleLogin}
            className="mt-6 w-full rounded-xl bg-amber-400 py-3 text-sm font-medium text-black hover:bg-amber-300 transition"
          >
            Login as Vendor
          </button>

          <div className="mt-8 text-center text-[11px] text-gray-500">
            Authorized Vendors Only • Secure & Encrypted
          </div>
        </div>
      </div>
    </div>
  );
}